export const getLinkWithQuery = (url, query) => {
  let queryString = ''
  for (const [key, value] of Object.entries(query)) {
    queryString += `&${key}=${value}`
  }
  return url + queryString.replace('&', '?')
}